const AVATAR = "/jerry.png";

export default function ChatLauncher({ onOpen }) {
    return (
        <button
            onClick={onOpen}
            aria-label="Chat with Jerry"
            data-testid="chatbot-open-button"
            className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 rounded-full bg-[#0E2A47] text-white pl-2 pr-5 py-2 shadow-lg shadow-[#0E2A47]/25 hover:bg-[#08182B] transition-all hover:scale-[1.02]"
        >
            <span className="relative">
                <img
                    src={AVATAR}
                    alt="Jerry"
                    className="h-10 w-10 rounded-full object-cover ring-2 ring-white/30"
                />
                <span className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full bg-[#7BA37F] ring-2 ring-[#0E2A47]" />
            </span>
            <span className="flex flex-col leading-tight items-start">
                <span className="font-[Outfit] font-semibold text-[14px]">Chat with Jerry</span>
                <span className="text-[10.5px] text-white/65 uppercase tracking-[0.12em]">
                    Virtual Receptionist
                </span>
            </span>
        </button>
    );
}
